export var variants = {
    DEFAULT: "default",
    INVERTED: "inverted"
};
